import React, { useState } from "react";

import { JobRegistry } from "../components/transcription/JobRegistry";
import { UploadCard } from "../components/transcription/UploadCard";
import { useUserGroups } from "../hooks/authHooks";

export const Transcription: React.FC = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const userGroups = useUserGroups();

  const uploadGroups = ["TranscriptionSingleUpload", "TranscriptionBulkUpload"];
  const viewGroups = ["TranscriptionSingleView", "TranscriptionBulkView"];
  const canUpload =
    uploadGroups.some((g) => userGroups.includes(g)) || userGroups.includes("GlobalAdmin");
  const canView =
    viewGroups.some((g) => userGroups.includes(g)) || userGroups.includes("GlobalAdmin");

  return (
    <div className="container mt-5 mb-5">
      <h1>Audio Transcription Service</h1>
      {canUpload && <UploadCard setRefreshTrigger={setRefreshTrigger} />}
      {canView && <JobRegistry refreshTrigger={refreshTrigger} />}
    </div>
  );
};
